<template>
  <b-card title="AkbankPos Yapılandırması">
    <b-form-group
      label="Merchant Safe ID"
      label-for="akbank_merchant_safe_id"
    >
      <b-form-input
        id="akbank_merchant_safe_id"
        v-model="akbank_merchant_safe_id"
        placeholder="Merchant Safe ID"
      />
    </b-form-group>
    <b-form-group
      label="Terminal Safe ID"
      label-for="akbank_terminal_safe_id"
    >
      <b-form-input
        id="akbank_terminal_safe_id"
        v-model="akbank_terminal_safe_id"
        placeholder="Terminal Safe ID"
      />
    </b-form-group>
    <b-form-group
      label="Secret Key"
      label-for="akbank_secret_key"
    >
      <b-form-input
        id="akbank_secret_key"
        v-model="akbank_secret_key"
        placeholder="Secret Key"
      />
    </b-form-group>
    <b-form-group
      label="Secure Pay Url"
      label-for="akbank_3d_url"
    >
      <b-form-input
        id="akbank_3d_url"
        v-model="akbank_3d_url"
        placeholder="Secure Pay Url"
      />
    </b-form-group>
    <b-form-group
      label="Process / API Url"
      label-for="akbank_api_url"
    >
      <b-form-input
        id="akbank_api_url"
        v-model="akbank_api_url"
        placeholder="Process / API Url"
      />
    </b-form-group>
  </b-card>
</template>
<script>
import { BCard, BFormGroup, BFormInput } from 'bootstrap-vue'
import { configField } from '@/views/PosConfigs/Configs/configBind'

export default {
  name: 'AkbankPos',
  components: {
    BCard,
    BFormGroup,
    BFormInput,
  },
  computed: {
    posConfig() {
      return this.$store.getters['posConfigs/getPos_config']
    },
    akbank_merchant_safe_id: configField('akbank_merchant_safe_id'),
    akbank_terminal_safe_id: configField('akbank_terminal_safe_id'),
    akbank_secret_key: configField('akbank_secret_key'),
    akbank_3d_url: configField('akbank_3d_url'),
    akbank_api_url: configField('akbank_api_url'),
  },
}
</script>
<style scoped></style>
